import React from 'react'
import { InfoIconWrapper } from './BountyContent.styled'

interface InfoIconProps {
  onClick?: () => void
  showOnlyInfo?: boolean
  disabled?: boolean
}

const InfoIcon: React.FC<InfoIconProps> = React.memo(({ onClick, showOnlyInfo, disabled }) => {
  if (showOnlyInfo || disabled) {
    return <InfoIconWrapper />
  }

  return (
    <InfoIconWrapper>
      <svg
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="28"
        viewBox="0 0 27 28"
        fill="none"
        className={`cursor-pointer group ${disabled ? 'filter grayscale' : ''}`}
      >
        <path
          d="M0 19.25V28H1.6875L2.53125 27.125H19.4062L20.25 28H26.1562V21.875L25.3125 21V9.625L27 7.875V2.625L24.4688 0H22.7812L20.25 2.625H9.28125L7.59375 0.875H0.84375V4.375L1.6875 6.125V17.5L0 19.25Z"
          fill="#F30C6D"
        />
        <path d="M14.7862 17.3315H12.8554L11.7391 16.1583V7.30432H13.6548L14.7862 8.47755V17.3315Z" fill="white" />
        <path d="M14.7862 23.5575H12.8554L11.7391 22.3843V20.5071H14.7862V23.5575Z" fill="white" />
      </svg>
    </InfoIconWrapper>
  )
})

InfoIcon.displayName = 'InfoIcon'
export default InfoIcon
